export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ12.463e6d5c.mp3";